export default __webpack_public_path__ + "static/joko-app-screenshot-home-fr@2x-d64e6d9a7a2e6556a1af9a94ff24ec45.png";